// Production configuration
const config = {
  development: {
    API_BASE_URL: 'http://localhost:3001/api',
    BASE_URL: 'http://localhost:3000'
  },
  production: {
    API_BASE_URL: 'https://greenauto24.ru/api',
    BASE_URL: 'https://greenauto24.ru'
  }
};

// Определяем среду выполнения
const environment = process.env.NODE_ENV || 'development';

export const API_BASE_URL = config[environment].API_BASE_URL;
export const BASE_URL = config[environment].BASE_URL;
export const IS_DEVELOPMENT = environment === 'development';
